import NumberRangeController from './number_range_controller';

export default class NumberRangeWithUnitSelectController extends NumberRangeController {
  static targets = ['unit'];

  _getUnit() {
    return this.unitTarget.value ?? '';
  }
}
